// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/pit-rates",
  Create: "/pyr/pit-rates",
  Update: "/pyr/pit-rates",
};
